module.exports = __webpack_public_path__ + "img/successImg.2943bf46.png";